import React from 'react';
import { Box, FormHelperText, FormLabel, IconButton, Stack, Tooltip } from '@mui/material';
import { BasicAutocomplete } from 'components/common/basic-autocomplite/BasicAutocomplite';
import IconMi from 'components/common/icon/IconMi';
import useBundleTranslation from 'i18n';
import { ColumnData } from 'components/dataset-viewer';
import { IRuleDisplayTemplate } from './useRuleDisplayTemplate';
export default function DisplayTemplateField({
    columnsData,
    setIsDefaultTemplate,
    setFilterDirty,
    suggestion,
    displayTemplate,
    noPadding = false,
}: {
    columnsData: ColumnData[];
    setIsDefaultTemplate: (value: boolean) => void;
    setFilterDirty: (value: boolean) => void;
    suggestion: string;
    displayTemplate: IRuleDisplayTemplate;
    noPadding?: boolean;
}) {
    const { t } = useBundleTranslation('app/report/report-alert-rule');

    return (
        <Box sx={noPadding ? {} : { pt: 3, px: 3 }}>
            <FormLabel>{t('rule_display_template')}</FormLabel>
            <Stack direction="row" alignItems="flex-start" spacing={0.5}>
                <Box sx={{ flex: 1 }}>
                    <BasicAutocomplete
                        options={columnsData.map((col) => ({
                            label: col.name,
                            value: col.column_name,
                        }))}
                        wrapValue
                        expression={displayTemplate.ruleDisplayTemplate}
                        setExpression={(value) => {
                            displayTemplate.setRuleDisplayTemplate(value);
                            setIsDefaultTemplate(false);
                            if (value.trim()) {
                                displayTemplate.setRuleDisplayTemplateError(false);
                            }
                            setFilterDirty(true);
                        }}
                        expressionError={displayTemplate.ruleDisplayTemplateError}
                        setExpressionError={displayTemplate.setRuleDisplayTemplateError}
                        placeholder={t('autosuggest')}
                    />
                    {displayTemplate.ruleDisplayTemplateError && (
                        <FormHelperText error>{t('rule_display_template_required')}</FormHelperText>
                    )}
                </Box>
                <Tooltip title={t('reset_to_suggestion')}>
                    <IconButton
                        size="small"
                        onClick={() => {
                            displayTemplate.setRuleDisplayTemplate(suggestion);
                            setIsDefaultTemplate(true);
                            displayTemplate.setRuleDisplayTemplateError(false);
                            setFilterDirty(true);
                        }}
                        sx={{ mt: 0.5 }}
                    >
                        <IconMi icon="rotate-ccw" sx={{ fontSize: '16px' }} />
                    </IconButton>
                </Tooltip>
            </Stack>
        </Box>
    );
}
